import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'
import { APP_LOGIN_URL } from '@/config'

const plans = [
  {
    name: 'Free',
    price: 'Rs 0',
    period: '',
    description: 'For anyone getting started',
    features: [
      'Track income and expenses',
      'Customer credit tracking',
      'Basic financial reports',
      'Cloud backup',
      'Works on any device',
      'Community support',
    ],
    cta: 'Start for Free',
    ctaHref: APP_LOGIN_URL,
    highlighted: false,
  },
  {
    name: 'Business',
    price: 'Rs 990',
    period: '/month',
    description: 'For growing small businesses',
    features: [
      'Everything in Free',
      'Unlimited transactions',
      'Receipt capture and storage',
      'Advanced reports and insights',
      'Accountant access',
      'Priority support',
    ],
    cta: 'Start Free Trial',
    ctaHref: `${APP_LOGIN_URL}?plan=business`,
    highlighted: true,
  },
  {
    name: 'Business Plus',
    price: 'Rs 2,900',
    period: '/month',
    description: 'For businesses ready to scale',
    features: [
      'Everything in Business',
      'Multiple users and staff access',
      'Credit insights and loan readiness',
      'Invoicing and billing',
      'Dedicated account manager',
      'API access',
    ],
    cta: 'Start Free Trial',
    ctaHref: `${APP_LOGIN_URL}?plan=plus`,
    highlighted: false,
  },
]

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Pricing"
        description="Simple, transparent pricing for Ledger. Start for free. Affordable plans for micro and small businesses in Sri Lanka."
        canonical="/pricing"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h1 className="text-4xl font-bold text-surface-900 mb-4">
              Simple pricing that grows with your business
            </h1>
            <p className="text-lg text-surface-600">
              Start for free. Upgrade when you're ready. No credit card required.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {plans.map((plan) => (
              <div
                key={plan.name}
                className={`card p-6 ${plan.highlighted ? 'border-2 relative' : ''}`}
                style={plan.highlighted ? { borderColor: '#08C6EA' } : {}}
              >
                {plan.highlighted && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 text-white text-xs font-medium rounded-full" style={{ backgroundColor: '#08C6EA' }}>
                    Most Popular
                  </div>
                )}

                <div className="mb-6">
                  <h3 className="text-lg font-semibold text-surface-900">{plan.name}</h3>
                  <div className="mt-2 flex items-baseline gap-1">
                    <span className="text-4xl font-bold text-surface-900">{plan.price}</span>
                    <span className="text-surface-500">{plan.period}</span>
                  </div>
                  <p className="mt-2 text-sm text-surface-500">{plan.description}</p>
                </div>

                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-3 text-sm">
                      <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="#08C6EA">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                      <span className="text-surface-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href={plan.ctaHref}
                  className={`block w-full btn text-center ${plan.highlighted ? 'btn-primary' : 'btn-secondary'}`}
                >
                  {plan.cta}
                </a>
              </div>
            ))}
          </div>

          <p className="text-center text-sm text-surface-500 mt-8">
            All prices in LKR, billed monthly. Annual billing available at a discount.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  )
}
